import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(<path d="M12 10L8 14H16L12 10Z" />, 'DropUpFill');
